// Shared money formatter for every dashboard widget. Extracted in Phase 4 from the private
// copies in accountingWidgets/salesWidgets/expenseWidgets and the inline toLocaleString calls
// in inventoryWidgets/payrollWidgets. Output format is load-bearing: widget tests assert
// strings like '1,100.00', so any change here is a breaking change to those suites.

// The locale is pinned rather than left to the browser. With `undefined` the grouping and the
// digits followed whatever locale the viewer's browser reported, so the same figure rendered as
// '1,100.00' for one user, '1.100,00' for another, and in Bengali numerals with lakh/crore
// grouping under bn-BD — while every test (and the invoice PDF) assumed en-US. Money on the
// dashboard has to tie out against documents, so the format is fixed here.
const MONEY_LOCALE = 'en-US';

/**
 * The only currency this product bills and reports in (bKash/BDT, AmountInWords, invoice PDFs).
 * (final-review F5: `utils/currency.ts`'s `formatMoney` -- the POS screens' own money formatter
 * -- embeds this same symbol itself, whereas `fmtMoney` below never does; dashboard call sites
 * pass CURRENCY_SYMBOL separately as StatTile's `unit`. The digits agree for non-negative values
 * and differ only in sign placement for negatives. Two functions on purpose, not one.)
 */
export const CURRENCY_SYMBOL = '৳';

export function fmtMoney(n: number): string {
    return n.toLocaleString(MONEY_LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
